export const isProduction = process.env.NODE_ENV === "production";
export const isLocal = process.env.APP_ENV === "local" || process.env.APP_ENV === "testing";
